import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-afspraak-maken',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconAfspraakMaken {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M17.98 0C8.05 0 0 8.06 0 18s8.05 18 17.98 18S36 27.94 36 18 27.94 0 17.98 0M18 34C9.18 34 2 26.82 2 18S9.18 2 18 2s16 7.18 16 16-7.18 16-16 16"/>
  <path d="M18 4C10.28 4 4 10.28 4 18s6.28 14 14 14 14-6.28 14-14S25.72 4 18 4m9 19.49c-.27.48-.88.66-1.36.39l-8.13-4.51a.992.992 0 0 1-.51-.87V7.49c0-.55.45-1 1-1s1 .45 1 1V17.9l7.61 4.23c.48.27.66.88.39 1.36"/>
</svg>

    );
  }
}
